import type { Enums } from '@powerful/types';

import { getSupabaseClient } from '../supabase';

export type BusinessStatus = Enums<'business_status'>;

export type BusinessErrorCode = 'load_failed' | 'network';

export type BusinessResult<T> =
  | { ok: true; data: T }
  | { ok: false; code: BusinessErrorCode; message: string };

export interface OwnBusiness {
  id: string;
  status: BusinessStatus;
}

/** Resumo mínimo do negócio do dono — `id` e `status`, nada mais. */
export async function loadOwnBusiness(): Promise<BusinessResult<OwnBusiness | null>> {
  try {
    const client = getSupabaseClient();
    const { data: userData } = await client.auth.getUser();
    const userId = userData?.user?.id;

    if (!userId) return { ok: true, data: null };

    const { data, error } = await client
      .from('businesses')
      .select('id, status')
      .eq('owner_id', userId)
      .maybeSingle();

    if (error) {
      return {
        ok: false,
        code: 'load_failed',
        message: 'Não foi possível carregar o negócio.',
      };
    }

    if (!data) return { ok: true, data: null };

    return {
      ok: true,
      data: { id: data.id, status: data.status },
    };
  } catch {
    return { ok: false, code: 'network', message: 'Sem ligação. Tente novamente.' };
  }
}
